import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-center h-full" }
const _hoisted_2 = { class: "flex-grow md:rounded-md overflow-hidden dark:bg-white dark:bg-opacity-5 h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AgGridVue = _resolveComponent("AgGridVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AgGridVue, _mergeProps(_ctx.$attrs, {
        class: "ag-theme-material h-full",
        cacheBlockSize: _ctx.count,
        gridOptions: _ctx.gridOptions,
        columnDefs: _ctx.columnDefs,
        defaultColDef: _ctx.defaultColDef,
        onGridReady: _ctx.onGridReady,
        onFirstDataRendered: _ctx.resizeGrid,
        rowHeight: _ctx.rowHeight,
        rowClass: "border-none cursor-pointer hover:!bg-blue-100 dark:hover:!bg-blue-900"
      }), null, 16, ["cacheBlockSize", "gridOptions", "columnDefs", "defaultColDef", "onGridReady", "onFirstDataRendered", "rowHeight"])
    ])
  ]))
}